module.exports = __webpack_public_path__ + "static/media/  (33).4541b083.jpg";